const baseURL = process.env.REACT_APP_BACKEND_API_URL;

export { baseURL };
